export const SELECT_FILE = 'SELECT_FILE';
export const SELECT_PRESET = 'SELECT_PRESET';
export const ASSET_INFO = 'ASSET_INFO';
export const CREATE_PRESET = 'CREATE_PRESET';
export const SUMMARY_AND_SAVE = 'SUMMARY_AND_SAVE';
